import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Divider,
  Avatar,
  Button
} from '@mui/material';
import './MissionDetailsModal.css';

const MissionDetailsModal = ({ open, onClose, mission }) => {
  if (!mission) return null;

  const descriptionPreview = mission.description
    ? mission.description.slice(0, 100) + (mission.description.length > 100 ? '...' : '')
    : 'Aucune description fournie.';

  const logoUrl = mission.logoUrl
    ? `${process.env.REACT_APP_API_BASE_URL}${mission.logoUrl}`
    : '';
  const fallbackInitial = mission.company?.charAt(0)?.toUpperCase() || 'E';

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="modal-box">
        <div className="modal-header">
          {!logoUrl ? (
            <Avatar className="modal-logo-fallback">{fallbackInitial}</Avatar>
          ) : (
            <img src={logoUrl} alt="logo" className="modal-logo" />
          )}
          <Typography className="modal-title">{mission.title}</Typography>
        </div>

        <Divider className="modal-divider" />

        <Typography className="modal-label">Entreprise :</Typography>
        <Typography className="modal-text">{mission.company}</Typography>

        <Typography className="modal-label">Description :</Typography>
        <Typography className="modal-text">{descriptionPreview}</Typography>

        <Typography className="modal-label">Date limite :</Typography>
        <Typography className="modal-text">{mission.deadline || 'Non précisée'}</Typography>

        <Typography className="modal-label">Lieu :</Typography>
        <Typography className="modal-text">{mission.location || 'Ville inconnue'}</Typography>

        <Typography className="modal-label">Profils recherchés :</Typography>
        <Typography className="modal-text">
          {mission.availableSpots || 0} profil(s)
        </Typography>

        <div className="modal-actions">
          <Button variant="outlined" onClick={onClose}>Fermer</Button>
          <Button
            variant="contained"
            onClick={() => window.location.href = `/Recruteur/Details/${mission._id}`}
          >
            Voir plus
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default MissionDetailsModal;
